import posthog from "posthog-js";

export function initPostHog() {
  const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
  const host = import.meta.env.VITE_POSTHOG_HOST;

  if (!token) return;

  posthog.init(token, {
    api_host: host || "https://us.i.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    autocapture: true,
    capture_pageview: true,
  });
}

export function captureException(error: unknown): void {
  posthog.captureException(error);
}

export default posthog;
